// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var IOUtils = require("../../../../shared/src/IOUtils.bs.js");
var ReactIO = require("../../../../shared/src/ReactIO.bs.js");
var DomUtils = require("../../../../shared/src/DomUtils.bs.js");
var Reselect = require("../../../../shared/src/bindings/Reselect.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var WebEnvVars = require("../../WebEnvVars.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var FormalityCompat = require("re-formality/src/FormalityCompat.bs.js");
var Relude_Js_Promise = require("relude/src/js/Relude_Js_Promise.bs.js");
var WebGraphql_Shifts = require("../../graphql/WebGraphql_Shifts.bs.js");
var CommonTypes_Geocode = require("../../../../shared/src/types/CommonTypes_Geocode.bs.js");
var BrowserComponents_Icon = require("../../../../shared-browser/src/components/BrowserComponents_Icon.bs.js");
var BrowserComponents_Field = require("../../../../shared-browser/src/components/BrowserComponents_Field.bs.js");
var BrowserComponents_Input = require("../../../../shared-browser/src/components/BrowserComponents_Input.bs.js");
var BrowserComponents_Spacer = require("../../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_Subtext = require("../../../../shared-browser/src/components/BrowserComponents_Subtext.bs.js");
var BrowserComponents_Dropdown = require("../../../../shared-browser/src/components/BrowserComponents_Dropdown.bs.js");
var WebComponents_PostAShiftForm = require("../../components/WebComponents_PostAShiftForm.bs.js");
var CommonTypes_Business_Location = require("../../../../shared/src/types/business/CommonTypes_Business_Location.bs.js");
var BrowserBindings_GoogleMapReact = require("../../../../shared-browser/src/bindings/BrowserBindings_GoogleMapReact.bs.js");
var BrowserComponents_ValidationError = require("../../../../shared-browser/src/components/BrowserComponents_ValidationError.bs.js");
var FormalityCompat__FormAsyncOnChange = require("re-formality/src/FormalityCompat__FormAsyncOnChange.bs.js");
var BrowserComponents_SubmissionErrorModal = require("../../../../shared-browser/src/components/BrowserComponents_SubmissionErrorModal.bs.js");
var CommonTypes_Business_Location_ParkingCost = require("../../../../shared/src/types/business/CommonTypes_Business_Location_ParkingCost.bs.js");

var token = WebEnvVars.vars.googleMapsWebClientApiToken;

var mapContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.border(BrowserStyle.Input.borderWidth, "solid", {
            TAG: /* Grey */2,
            _0: /* Light */3
          }),
      tl: {
        hd: BrowserStyle.borderRadius(BrowserStyle.Input.borderRadius),
        tl: {
          hd: BrowserStyle.height(BrowserStyle.rem(12.5)),
          tl: /* [] */0
        }
      }
    });

var invisible = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display("none"),
      tl: /* [] */0
    });

Curry._2(BrowserStyle.$$global, ".location-map > div > div", {
      hd: BrowserStyle.borderRadius(BrowserStyle.rem(0.5)),
      tl: /* [] */0
    });

var Styles = {
  mapContainer: mapContainer,
  invisible: invisible
};

function initialState(savedLocations, fetchGeocodeForAddress) {
  return {
          address: "",
          fetchGeocodeForAddress: fetchGeocodeForAddress,
          hasConfirmedLongDistanceShiftIsOk: false,
          locationName: "",
          parkingCost: /* NotProvided */3,
          parkingInstructions: "",
          savedLocations: savedLocations,
          selectedLocation: undefined
        };
}

var getSavedLocation = Reselect.createSelector2(undefined, (function (param) {
        return param.selectedLocation;
      }), (function (param) {
        return param.savedLocations;
      }), (function (selectedLocationId, savedLocations) {
        return Curry._2(Relude_Array.find, (function (param) {
                      var id = param.id;
                      return Relude_Option.fold(false, (function (param) {
                                    return Curry._2(CommonTypes_Business_Location.Id.eq, id, param.id);
                                  }), selectedLocationId);
                    }), Relude_Set.toArray(savedLocations));
      }));

var debounceInterval = FormalityCompat.Async.debounceInterval;

function get(param) {
  return param.hasConfirmedLongDistanceShiftIsOk;
}

function update(setState, state, hasConfirmedLongDistanceShiftIsOk) {
  return Curry._2(setState, /* HasConfirmedLongDistanceShiftIsOk */1, {
              address: state.address,
              fetchGeocodeForAddress: state.fetchGeocodeForAddress,
              hasConfirmedLongDistanceShiftIsOk: hasConfirmedLongDistanceShiftIsOk,
              locationName: state.locationName,
              parkingCost: state.parkingCost,
              parkingInstructions: state.parkingInstructions,
              savedLocations: state.savedLocations,
              selectedLocation: state.selectedLocation
            });
}

var HasConfirmedLongDistanceShiftIsOkField = {
  get: get,
  update: update
};

var get$1 = Reselect.createSelector2(undefined, (function (param) {
        return param.locationName;
      }), getSavedLocation, (function (locationName, maybeSavedLocation) {
        return Relude_Option.getOrElse(locationName, Relude_Option.map((function (param) {
                          return param.name;
                        }), maybeSavedLocation));
      }));

function update$1(setState, state, locationName) {
  return Curry._2(setState, /* LocationName */2, {
              address: state.address,
              fetchGeocodeForAddress: state.fetchGeocodeForAddress,
              hasConfirmedLongDistanceShiftIsOk: state.hasConfirmedLongDistanceShiftIsOk,
              locationName: locationName,
              parkingCost: state.parkingCost,
              parkingInstructions: state.parkingInstructions,
              savedLocations: state.savedLocations,
              selectedLocation: state.selectedLocation
            });
}

function validator_validate(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great(get$1, Relude_String.toNonWhitespace, param);
                            }), (function (param) {
                              return Relude_Option.map((function (param) {
                                            return Relude_Globals.$$const(/* Valid */0, param);
                                          }), param);
                            }), param);
              }), (function (param) {
                return Relude_Result.fromOption("Please give a name to your location", param);
              }), param);
}

var validator = {
  field: /* LocationName */2,
  strategy: /* OnFirstBlur */0,
  dependents: undefined,
  validate: validator_validate,
  validateAsync: undefined
};

var LocationNameField = {
  get: get$1,
  update: update$1,
  validator: validator
};

var get$2 = Reselect.createSelector2(undefined, (function (param) {
        return param.address;
      }), getSavedLocation, (function (address, savedLocations) {
        return Relude_Option.fold(address, (function (param) {
                      return param.address;
                    }), savedLocations);
      }));

function update$2(setState, state, address) {
  return Curry._2(setState, /* Address */0, {
              address: address,
              fetchGeocodeForAddress: state.fetchGeocodeForAddress,
              hasConfirmedLongDistanceShiftIsOk: state.hasConfirmedLongDistanceShiftIsOk,
              locationName: state.locationName,
              parkingCost: state.parkingCost,
              parkingInstructions: state.parkingInstructions,
              savedLocations: state.savedLocations,
              selectedLocation: state.selectedLocation
            });
}

function getGeocode(state) {
  return Curry._2(Relude_IO.mapError, (function (param) {
                return Relude_Globals.$$const(/* InvalidAddress */0, param);
              }), Curry._1(state.fetchGeocodeForAddress, Curry._1(get$2, state)));
}

var partial_arg = Curry._1(Relude_IO.mapError, (function (param) {
        return Relude_Globals.$$const("Input a valid address", param);
      }));

function getAddressValidationResult(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great(getGeocode, (function (param) {
                              return Relude_IO.map((function (param) {
                                            return Relude_Globals.$$const(/* Valid */0, param);
                                          }), param);
                            }), param);
              }), partial_arg, param);
}

var partial_arg$1 = Relude_Result.ok(/* Valid */0);

function validator_validate$1(param) {
  return Relude_Globals.$$const(partial_arg$1, param);
}

var validator_validateAsync = [
  (function (param) {
      return Relude_Globals.$great$great((function (param) {
                    return Relude_Globals.$great$great((function (param) {
                                  return Relude_Globals.$great$great(getAddressValidationResult, (function (param) {
                                                return Relude_IO.map(Relude_Result.ok, param);
                                              }), param);
                                }), (function (param) {
                                  return Relude_IO.catchError((function (param) {
                                                return Relude_Globals.$great$great(Relude_Result.error, Relude_IO.pure, param);
                                              }), param);
                                }), param);
                  }), Relude_Js_Promise.fromIO, param);
    }),
  (function (prev, next) {
      return Relude_String.eq(Curry._1(get$2, prev), Curry._1(get$2, next));
    })
];

var validator$1 = {
  field: /* Address */0,
  strategy: /* OnFirstChange */1,
  dependents: undefined,
  validate: validator_validate$1,
  validateAsync: validator_validateAsync
};

var AddressField = {
  get: get$2,
  update: update$2,
  getGeocode: getGeocode,
  getAddressValidationResult: getAddressValidationResult,
  validator: validator$1
};

function get$3(param) {
  return param.parkingCost;
}

function update$3(setState, state, parkingCost) {
  return Curry._2(setState, /* ParkingCost */3, {
              address: state.address,
              fetchGeocodeForAddress: state.fetchGeocodeForAddress,
              hasConfirmedLongDistanceShiftIsOk: state.hasConfirmedLongDistanceShiftIsOk,
              locationName: state.locationName,
              parkingCost: parkingCost,
              parkingInstructions: state.parkingInstructions,
              savedLocations: state.savedLocations,
              selectedLocation: state.selectedLocation
            });
}

function validator_validate$2(param) {
  return Relude_Globals.$great$great(get$3, (function (param) {
                if (typeof param === "number" && param < 3) {
                  return Relude_Result.ok(/* Valid */0);
                } else {
                  return Relude_Result.error("Please select parking cost");
                }
              }), param);
}

var validator$2 = {
  field: /* ParkingCost */3,
  strategy: /* OnFirstChange */1,
  dependents: undefined,
  validate: validator_validate$2,
  validateAsync: undefined
};

var ParkingCostField = {
  get: get$3,
  update: update$3,
  validator: validator$2
};

function get$4(param) {
  return param.parkingInstructions;
}

function update$4(setState, state, parkingInstructions) {
  return Curry._2(setState, /* ParkingInstructions */4, {
              address: state.address,
              fetchGeocodeForAddress: state.fetchGeocodeForAddress,
              hasConfirmedLongDistanceShiftIsOk: state.hasConfirmedLongDistanceShiftIsOk,
              locationName: state.locationName,
              parkingCost: state.parkingCost,
              parkingInstructions: parkingInstructions,
              savedLocations: state.savedLocations,
              selectedLocation: state.selectedLocation
            });
}

function validator_validate$3(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great(get$4, Relude_String.toNonWhitespace, param);
                            }), (function (param) {
                              return Relude_Option.map((function (param) {
                                            return Relude_Globals.$$const(/* Valid */0, param);
                                          }), param);
                            }), param);
              }), (function (param) {
                return Relude_Result.fromOption("Give our Professionals arrival instructions", param);
              }), param);
}

var validator$3 = {
  field: /* ParkingInstructions */4,
  strategy: /* OnFirstBlur */0,
  dependents: undefined,
  validate: validator_validate$3,
  validateAsync: undefined
};

var ParkingInstructionsField = {
  get: get$4,
  update: update$4,
  validator: validator$3
};

function get$5(param) {
  return param.selectedLocation;
}

function update$5(setState, state, selectedLocation) {
  return Curry._2(setState, /* SelectedLocation */5, {
              address: state.address,
              fetchGeocodeForAddress: state.fetchGeocodeForAddress,
              hasConfirmedLongDistanceShiftIsOk: state.hasConfirmedLongDistanceShiftIsOk,
              locationName: state.locationName,
              parkingCost: state.parkingCost,
              parkingInstructions: state.parkingInstructions,
              savedLocations: state.savedLocations,
              selectedLocation: selectedLocation
            });
}

var partial_arg$2 = Relude_Result.ok(/* Valid */0);

var validator_dependents = Relude_Option.pure({
      hd: /* Address */0,
      tl: {
        hd: /* ParkingInstructions */4,
        tl: {
          hd: /* LocationName */2,
          tl: /* [] */0
        }
      }
    });

function validator_validate$4(param) {
  return Relude_Globals.$$const(partial_arg$2, param);
}

var validator$4 = {
  field: /* SelectedLocation */5,
  strategy: /* OnFirstChange */1,
  dependents: validator_dependents,
  validate: validator_validate$4,
  validateAsync: undefined
};

var SelectedLocationField = {
  get: get$5,
  update: update$5,
  validator: validator$4
};

function isShiftLongDistance(param) {
  var geocode = param.geocode;
  var partial_arg = Curry._1(Relude_Float.lessThanOrEq, 75.0);
  return function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return CommonTypes_Geocode.distanceBetweenMiles(geocode, param);
                }), partial_arg, param);
  };
}

function fromLocation(city, savedLocations, fetchGeocodeForAddress, param) {
  return {
          address: param.address,
          fetchGeocodeForAddress: fetchGeocodeForAddress,
          hasConfirmedLongDistanceShiftIsOk: isShiftLongDistance(city)(param.geocode),
          locationName: param.locationName,
          parkingCost: param.parkingCost,
          parkingInstructions: param.parkingInstructions,
          savedLocations: savedLocations,
          selectedLocation: param.existingLocation
        };
}

function toLocation(city, state) {
  return Relude_IO.map((function (geocode) {
                return {
                        address: Curry._1(get$2, state),
                        existingLocation: get$5(state),
                        geocode: geocode,
                        locationName: Curry._1(get$1, state),
                        parkingCost: get$3(state),
                        parkingInstructions: get$4(state)
                      };
              }), Relude_IO.flatMap((function (addressGeocode) {
                    var launchStatus = addressGeocode.launchStatus;
                    var geocode = addressGeocode.geocode;
                    var match = get(state);
                    var match$1 = isShiftLongDistance(city)(geocode);
                    if (typeof launchStatus === "number" && launchStatus >= 2) {
                      if (match || !match$1) {
                        return Relude_IO.pure(geocode);
                      } else {
                        return Relude_IO.$$throw(/* NeedsLongDistanceShiftConfirmation */1);
                      }
                    } else {
                      return Relude_IO.$$throw(/* NotLaunchedZipcode */{
                                  _0: addressGeocode
                                });
                    }
                  }), getGeocode(state)));
}

var validators_1 = {
  hd: validator$1,
  tl: {
    hd: validator$2,
    tl: {
      hd: validator$3,
      tl: {
        hd: validator$4,
        tl: /* [] */0
      }
    }
  }
};

var validators = {
  hd: validator,
  tl: validators_1
};

var Form = {
  initialState: initialState,
  getSavedLocation: getSavedLocation,
  debounceInterval: debounceInterval,
  HasConfirmedLongDistanceShiftIsOkField: HasConfirmedLongDistanceShiftIsOkField,
  LocationNameField: LocationNameField,
  AddressField: AddressField,
  ParkingCostField: ParkingCostField,
  ParkingInstructionsField: ParkingInstructionsField,
  SelectedLocationField: SelectedLocationField,
  maxShortDistanceLengthMiles: 75.0,
  isShiftLongDistance: isShiftLongDistance,
  fromLocation: fromLocation,
  toLocation: toLocation,
  validators: validators
};

var FormContainer = FormalityCompat__FormAsyncOnChange.Make({
      debounceInterval: debounceInterval,
      validators: validators
    });

function showSubmissionError(param, dismissSubmissionError, onLongDistanceConfirmationClick, param$1) {
  var cityName = param.cityName;
  if (typeof param$1 === "number") {
    return null;
  }
  if (param$1.TAG !== /* SubmissionFailed */1) {
    return null;
  }
  var match = param$1._0;
  if (typeof match === "number") {
    if (match !== 0) {
      return React.createElement(BrowserComponents_SubmissionErrorModal.make, {
                  cancelButton: {
                    text: "CHANGE LOCATION",
                    onClick: Curry._1(onLongDistanceConfirmationClick, false)
                  },
                  image: /* DistanceRoad */29,
                  okButton: {
                    text: "THAT IS THE CORRECT LOCATION",
                    onClick: Curry._1(onLongDistanceConfirmationClick, true)
                  },
                  subtext: "Please confirm that the shift you're attempting to post is over 75 miles from " + (cityName + ". We wouldn't want to have one of our Professionals show up at the wrong spot!"),
                  title: "This shift is greater than 75 miles from " + cityName
                });
    } else {
      return null;
    }
  } else {
    return React.createElement(BrowserComponents_SubmissionErrorModal.make, {
                cancelButton: {
                  text: "GOT IT",
                  onClick: dismissSubmissionError
                },
                image: /* DistanceRoad */29,
                subtext: "We are not quite ready to fill shifts at that address. We've jotted down your request and you'll be the first to know when we're ready to fill shifts in this area.",
                title: "Coming Soon"
              });
  }
}

function WebContainers_PostAShift_ShiftLocation(Props) {
  var authorizedClient = Props.authorizedClient;
  var city = Props.city;
  var fetchGeocodeForAddress = Props.fetchGeocodeForAddress;
  var param = Props.newShift;
  var onCancel = Props.onCancel;
  var savedLocations = Props.savedLocations;
  var setShiftLocation = Props.setShiftLocation;
  var match = Curry._2(FormContainer.useForm, Relude_Option.fold(initialState(savedLocations, fetchGeocodeForAddress), (function (param) {
              return fromLocation(city, savedLocations, fetchGeocodeForAddress, param);
            }), param.location), (function (state, param) {
          var notifyOnFailure = param.notifyOnFailure;
          return Relude_IO.unsafeRunAsync((function (param) {
                        return Relude_Result.fold(notifyOnFailure, (function (param) {
                                      return Relude_Globals.$great$great(setShiftLocation, (function (param) {
                                                    return Relude_IO.unsafeRunAsync((function (param) {
                                                                  return Relude_Result.fold(Relude_Globals.id, Relude_Globals.id, param);
                                                                }), param);
                                                  }), param);
                                    }), param);
                      }), Relude_IO.tapError((function (addressGeocode) {
                            if (typeof addressGeocode === "number") {
                              return ;
                            }
                            var partial_arg = Curry._1(WebGraphql_Shifts.AddNotLaunchedZipcodeInterest.mutate, addressGeocode._0);
                            return IOUtils.unsafeRunHandledAsync(Relude_IO.flatMap((function (param) {
                                              return Relude_Globals.$great$great(partial_arg, (function (param) {
                                                            return Relude_IO.bimap((function (prim) {
                                                                          
                                                                        }), (function (prim) {
                                                                          
                                                                        }), param);
                                                          }), param);
                                            }), Relude_IO.fromOption((function (prim) {
                                                  
                                                }), authorizedClient)));
                          }), toLocation(city, state)));
        }));
  var dismissSubmissionError = match.dismissSubmissionError;
  var submit = match.submit;
  var blur = match.blur;
  var change = match.change;
  var result = match.result;
  var state = match.state;
  ReactIO.useHandledIOOnMount(undefined)(DomUtils.$$Window.scrollToTop);
  var match$1 = React.useState(function () {
        return {
                currentFetchTimeout: undefined,
                geocode: undefined
              };
      });
  var setFetchGeocodeState = match$1[1];
  var match$2 = match$1[0];
  var geocode = match$2.geocode;
  var currentFetchTimeout = match$2.currentFetchTimeout;
  var updateCurrentFetchTimeout = function (nextFetchTimeout) {
    Relude_Option.fold(undefined, (function (prim) {
            clearTimeout(prim);
            
          }), currentFetchTimeout);
    return Relude_Globals.$great$great(Relude_Globals.$$const, setFetchGeocodeState, {
                currentFetchTimeout: nextFetchTimeout,
                geocode: geocode
              });
  };
  React.useEffect((function () {
          updateCurrentFetchTimeout(Relude_Option.pure(setTimeout((function (param) {
                          return Relude_IO.unsafeRunAsync((function (param) {
                                        return Relude_Result.fold((function (param) {
                                                      return Relude_Globals.$great$great(Relude_Globals.$$const, setFetchGeocodeState, {
                                                                  currentFetchTimeout: undefined,
                                                                  geocode: undefined
                                                                });
                                                    }), (function (param) {
                                                      var param_geocode = Relude_Option.pure(param.geocode);
                                                      var param$1 = {
                                                        currentFetchTimeout: undefined,
                                                        geocode: param_geocode
                                                      };
                                                      return Relude_Globals.$great$great(Relude_Globals.$$const, setFetchGeocodeState, param$1);
                                                    }), param);
                                      }), Curry._2(Relude_IO.mapError, (function (param) {
                                            return Relude_Globals.$$const(undefined, param);
                                          }), getGeocode(state)));
                        }), debounceInterval)));
          return Relude_Option.pure(function (param) {
                      return updateCurrentFetchTimeout(undefined);
                    });
        }), [Curry._1(get$2, state)]);
  var partial_arg = {
    TAG: /* Shift */6,
    _0: /* Location */13
  };
  var partial_arg$1 = get$5(state);
  var tmp = {
    icon: Relude_Option.fold({
          TAG: /* Status */8,
          _0: /* CirclePlus */8
        }, (function (param) {
            return Relude_Globals.$$const(partial_arg, param);
          }), get$5(state)),
    isItemSelected: (function (param) {
        return Relude_Option.eqBy(CommonTypes_Business_Location.eq, partial_arg$1, param);
      }),
    items: {
      TAG: /* Set */2,
      _0: Curry._1(CommonTypes_Business_Location.SetWithNone.fromSet, savedLocations)
    },
    itemToDisplayString: (function (param) {
        return Relude_Option.fold("Add New Location", (function (param) {
                      return param.name;
                    }), param);
      }),
    onBlur: Relude_IO.suspend(function (param) {
          return Curry._1(blur, /* SelectedLocation */5);
        }),
    onSelectItem: (function (param) {
        return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                      return Relude_IO.map((function (param) {
                                    return update$5(change, state, param);
                                  }), param);
                    }), param);
      }),
    testId: "LocationSelector",
    title: "Select Location"
  };
  var tmp$1 = Curry._1(result, /* SelectedLocation */5);
  if (tmp$1 !== undefined) {
    tmp.validationStatus = Caml_option.valFromOption(tmp$1);
  }
  var tmp$2 = {
    defaultEmptyText: "Select Parking Cost",
    icon: {
      TAG: /* Shift */6,
      _0: /* Car */5
    },
    isItemSelected: Curry._1(CommonTypes_Business_Location_ParkingCost.eq, get$3(state)),
    items: {
      TAG: /* Set */2,
      _0: Relude_Set.reject((function (param) {
              if (typeof param === "number") {
                return param >= 3;
              } else {
                return true;
              }
            }), CommonTypes_Business_Location_ParkingCost.set)
    },
    itemToDisplayString: CommonTypes_Business_Location_ParkingCost.toDisplayString,
    onBlur: Relude_IO.suspend(function (param) {
          return Curry._1(blur, /* ParkingCost */3);
        }),
    onSelectItem: (function (param) {
        return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                      return Relude_IO.map((function (param) {
                                    return update$3(change, state, param);
                                  }), param);
                    }), param);
      }),
    title: "Parking Cost"
  };
  var tmp$3 = Curry._1(result, /* ParkingCost */3);
  if (tmp$3 !== undefined) {
    tmp$2.validationStatus = Caml_option.valFromOption(tmp$3);
  }
  return React.createElement(WebComponents_PostAShiftForm.LegacyForm.make, {
              backButtonTitle: "Cancel",
              children: null,
              onBackButtonClick: onCancel,
              submit: submit,
              subtitle: "Where is your event happening?",
              testIdPrefix: "Locations",
              title: "Location"
            }, showSubmissionError(city, Relude_IO.suspend(dismissSubmissionError), (function (isCorrectLocation) {
                    return Relude_IO.suspend(function (param) {
                                return Curry._1(isCorrectLocation ? submit : (function (prim) {
                                                
                                              }), Curry._1(dismissSubmissionError, update(change, state, isCorrectLocation)));
                              });
                  }), match.status), React.createElement(BrowserComponents_Dropdown.make, tmp), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Medium */4
                }), React.createElement(BrowserComponents_Input.make, Curry._4(BrowserComponents_Input.makeProps(Curry._1(result, /* LocationName */2))(undefined, undefined, undefined, undefined, Relude_Option.isSome(get$5(state)), undefined, {
                          TAG: /* Shift */6,
                          _0: /* Direction */11
                        }, undefined, undefined, undefined, undefined, Relude_IO.suspend(function (param) {
                              return Curry._1(blur, /* LocationName */2);
                            }), undefined, undefined, undefined, undefined, undefined, "LocationNameInput", undefined, "Location Name", undefined, undefined, undefined, undefined), {
                      TAG: /* Text */7,
                      _0: {
                        onChange: (function (param) {
                            return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                                          return Relude_IO.map((function (param) {
                                                        return update$1(change, state, param);
                                                      }), param);
                                        }), param);
                          }),
                        value: Curry._1(get$1, state)
                      }
                    }, undefined, undefined, undefined)), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Medium */4
                }), React.createElement(BrowserComponents_Field.Title.make, {
                  title: "Address"
                }), React.createElement(BrowserComponents_Subtext.make, {
                  className: invisible,
                  children: "I am here to juke out google"
                }), React.createElement(BrowserComponents_Input.Legacy.Address.make, {
                  disabled: Relude_Option.isSome(get$5(state)),
                  value: Curry._1(get$2, state),
                  icon: {
                    TAG: /* Shift */6,
                    _0: /* Location */13
                  },
                  onChange: (function (param) {
                      return update$2(change, state, param);
                    }),
                  onBlur: (function (param) {
                      return Curry._1(blur, /* Address */0);
                    }),
                  testId: "AddressInput"
                }), React.createElement(BrowserComponents_ValidationError.make, {
                  validationResult: Curry._1(result, /* Address */0)
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Medium */4
                }), React.createElement(BrowserComponents_Dropdown.make, tmp$2), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Medium */4
                }), React.createElement(BrowserComponents_Input.make, Curry._4(BrowserComponents_Input.makeProps(Curry._1(result, /* ParkingInstructions */4))(undefined, undefined, undefined, undefined, undefined, undefined, {
                          TAG: /* Shift */6,
                          _0: /* Clipboard */8
                        }, undefined, undefined, undefined, undefined, Relude_IO.suspend(function (param) {
                              return Curry._1(blur, /* ParkingInstructions */4);
                            }), undefined, undefined, undefined, undefined, undefined, "ArrivalInstructions", undefined, "Arrival Instructions", undefined, undefined, undefined, undefined), {
                      TAG: /* Text */7,
                      _0: {
                        onChange: (function (param) {
                            return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                                          return Relude_IO.map((function (param) {
                                                        return update$4(change, state, param);
                                                      }), param);
                                        }), param);
                          }),
                        value: get$4(state)
                      }
                    }, undefined, undefined, undefined)), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* XXXLarge */8
                }), React.createElement("div", {
                  className: Curry._1(BrowserStyle.merge, {
                        hd: mapContainer,
                        tl: {
                          hd: "location-map",
                          tl: /* [] */0
                        }
                      })
                }, Relude_Option.fold(null, (function (geoPoint) {
                        return React.createElement(BrowserBindings_GoogleMapReact.make, BrowserBindings_GoogleMapReact.makeProps(undefined, Caml_option.some(React.createElement(BrowserBindings_GoogleMapReact.PositionalChild.make, BrowserBindings_GoogleMapReact.PositionalChild.makeProps(geoPoint, React.createElement(BrowserComponents_Icon.make, {
                                                        icon: {
                                                          TAG: /* Small */1,
                                                          _0: {
                                                            TAG: /* Shift */6,
                                                            _0: /* Location */13
                                                          }
                                                        },
                                                        size: /* Small */1
                                                      }), undefined, undefined))), 16, token, geoPoint, undefined, undefined));
                      }), geocode)));
}

var make = WebContainers_PostAShift_ShiftLocation;

exports.token = token;
exports.Styles = Styles;
exports.Form = Form;
exports.FormContainer = FormContainer;
exports.showSubmissionError = showSubmissionError;
exports.make = make;
/* mapContainer Not a pure module */
